import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const abstract = {
    state: () => ({
        abstract: {},
    }),

    mutations: {
        setAbstract(state, payload) {
            state.abstract = payload;
        },
    },

    actions: {
        async abstractGet(store) {
            var res = await axios.post('/Abstract/Get');
            store.commit('setAbstract', res.data.data.item);
            return res;
        },
        async abstractUpdatePackages(store, payload) {
            var res = await axios.post('/Abstract/UpdatePackages', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async abstractUpdateTopics(store, payload) {
            var res = await axios.post('/Abstract/UpdateTopics', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async abstractUpdateAuthors(store, payload) {
            var res = await axios.post('/Abstract/UpdateAuthors', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async abstractUpdateGeneralSettings(store, payload) {
            var res = await axios.post('/Abstract/UpdateGeneralSettings', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async abstractUpdateDetailSettings(store, payload) {
            var res = await axios.post('/Abstract/UpdateDetailSettings', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async abstractUpdateRules(store, payload) {
            var res = await axios.post('/Abstract/UpdateRules', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async abstractUpdateEvaluationSettings(store, payload) {
            var res = await axios.post('/Abstract/UpdateEvaluationSettings', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default abstract;


// WEBPACK FOOTER //
// ./src/store/abstract.js